(function(){
  'use strict';
  var root=document.querySelector('[data-saver]'); if(!root) return;
  var KEY_SHOWN='mo_saver_shown', KEY_DONE='mo_saver_done';
  function ss(k,v){ try{ if(v===undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k,v);}catch(e){ return null; } }
  function ls(k,v){ try{ if(v===undefined) return localStorage.getItem(k); localStorage.setItem(k,v);}catch(e){ return null; } }
  var days=parseFloat(root.getAttribute('data-days'))||7, done=parseInt(ls(KEY_DONE)||'0',10);
  if(done && Date.now()-done < days*864e5) return;

  var mobile=window.matchMedia&&window.matchMedia('(max-width: 800px)').matches;
  var t0=Date.now(), shown=false;
  function money(c){ return window.moMoney ? window.moMoney(c) : '$'+(c/100).toFixed(2); }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(ch){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[ch]; }); }
  function busy(){
    if(document.querySelector('[data-cart-drawer].is-open,[data-quiz-modal].is-open,[data-mobile-nav].is-open')) return true;
    var w=document.querySelector('[data-wheel]'); return !!(w && !w.hidden);
  }
  function wonCode(){ var c=ls('mo_wheel_won'); return c && c!=='1' ? c : ''; }
  function code(){ return wonCode() || root.getAttribute('data-code') || ''; }

  function fill(cart){
    var it=cart.items[0], more=cart.item_count-it.quantity;
    var img=it.image ? '<img src="'+esc(it.image.replace(/(\.[a-z]+)(\?|$)/,'_200x$1$2'))+'" alt="" width="64" height="64">' : '';
    root.querySelector('[data-saver-item]').innerHTML=
      '<span class="saver__img">'+img+'</span>'
      +'<span class="saver__meta"><strong>'+esc(it.product_title)+'</strong>'
      +(it.variant_title && it.variant_title!=='Default Title' ? '<small>'+esc(it.variant_title)+(more>0?' + '+more+' more':'')+'</small>' : '')
      +'</span><span class="saver__price">'+money(cart.total_price)+'</span>';
    var c=code(), perk=root.querySelector('[data-saver-perk]');
    var tpl=wonCode() ? root.getAttribute('data-perk-won') : root.getAttribute('data-perk');
    if(c && tpl){ perk.textContent=tpl.replace('[code]',c); perk.hidden=false; } else { perk.hidden=true; }
  }
  function maybe(){
    if(shown || ss(KEY_SHOWN) || busy() || Date.now()-t0<8000) return;
    fetch((window.MO&&window.MO.cartJsonUrl)||'/cart.js',{credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        if(!cart || !cart.item_count || shown || busy()) return;
        fill(cart); shown=true; ss(KEY_SHOWN,'1');
        var known=ls('mo_lead_email'); if(known){ root.querySelector('[data-saver-email]').value=known; }
        root.hidden=false; document.body.classList.add('saver-open');
        try{ if(window.moProtect) window.moProtect(root.querySelector('[data-saver-customer]')); }catch(x){}
        if(!mobile){ var e=root.querySelector('[data-saver-email]'); setTimeout(function(){ try{e.focus();}catch(x){} },250); }
      }).catch(function(){});
  }
  function hide(){ root.hidden=true; document.body.classList.remove('saver-open'); }
  root.querySelectorAll('[data-saver-close]').forEach(function(b){ b.addEventListener('click',hide); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape' && !root.hidden) hide(); });

  /* triggers: leaving with a full basket */
  if(!mobile){
    document.addEventListener('mouseout',function(e){ if(!e.relatedTarget && e.clientY<=0) maybe(); });
  }
  var awayAt=0;
  document.addEventListener('visibilitychange',function(){
    if(document.hidden){ awayAt=Date.now(); }
    else if(awayAt && Date.now()-awayAt>10000){ setTimeout(maybe,600); }
  });
  var checkoutClicked=false;
  document.addEventListener('click',function(e){
    var t=e.target.closest ? e.target.closest('[data-checkout],[name="checkout"],.shopify-payment-button,.express-pay,[data-close-cart]') : null;
    if(!t) return;
    if(t.hasAttribute('data-close-cart')){
      setTimeout(function(){ if(!checkoutClicked) maybe(); },9000);
    } else { checkoutClicked=true; }
  },true);

  /* submit: email goes straight into checkout (and to the list only if they opt in) */
  var form=root.querySelector('[data-saver-form]'), err=root.querySelector('[data-saver-error]');
  form.addEventListener('submit',function(e){
    e.preventDefault();
    var email=(root.querySelector('[data-saver-email]').value||'').trim();
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)){ err.hidden=false; return; }
    err.hidden=true;
    var btn=root.querySelector('[data-saver-go]'); btn.disabled=true;
    ls(KEY_DONE,String(Date.now()));
    try{ if(window.moTrack) window.moTrack('Lead',{content_name:'Basket saver'}); }catch(x){}
    var go=function(){
      var c=code(), url='/checkout?checkout%5Bemail%5D='+encodeURIComponent(email)+(c?'&discount='+encodeURIComponent(c):'');
      location.href=url;
    };
    ls('mo_lead_email',email);
    if(root.querySelector('[data-saver-optin]').checked && window.moSubscribe){
      var cf=root.querySelector('[data-saver-customer]');
      var sent=false, next=function(){ if(!sent){ sent=true; go(); } };
      window.moSubscribe(cf,email,next);
      setTimeout(next,4000);
    } else { go(); }
  });
})();
